import React, { PropTypes } from 'react';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { withRouter } from 'react-router';
import { locationShape } from 'react-router/lib/PropTypes';
import BibScreenReaderDescription from '@bibliocommons/shared-bib-screen-reader-description';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import { PrimaryButton } from '@bibliocommons/base-buttons';
import { Plus, Arrows } from '@bibliocommons/base-icons';
import { CatalogueResultItemButton, CatalogueResultItemAlert } from '@bibliocommons/add-title';
import { AddTitleOverlay } from '../../../components/shared/AddTitle/AddTitleOverlay';
import AddTitleContainer from '../../../containers/shared/AddTitle/AddTitleContainer';

import './ShelfAddTitleButton.scss';

export class ShelfAddTitleButton extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('closeEditor', 'openEditor', 'handleAdd', 'handleMove', 'renderAddOn');
    this.state = {
      showEditor: false,
      itemsAddedHash: {},
      isUpdatingResultItem: false,
      anyTransactionSuccess: false // determines if at least one transaction has been successful
    };
  }

  closeEditor() {
    this.setState({ showEditor: false });
    if (this.state.anyTransactionSuccess) {
      const { location, ownerId, shelfActions, currentShelfName } = this.props;
      shelfActions.searchUserShelf(currentShelfName, ownerId, { ...location.query, page: undefined });
    }
  }

  openEditor() {
    this.setState({ showEditor: true, anyTransactionSuccess: false });
  }

  renderOverlay() {
    return this.state.showEditor && (
      <AddTitleContainer
        handleClose={this.closeEditor}
        renderAddOn={this.renderAddOn}
        isUpdatingResultItem={this.state.isUpdatingResultItem}
        isWrappedInForm />
    );
  }

  renderScreenReaderMessage(item) {
    const shelfLabelEnum = {
      completed: 'label_my_shelf_completed',
      in_progress: 'label_my_shelf_in_progress',
      for_later: 'label_my_shelf_for_later'
    };

    return (<FormattedMessage
      id="ada_label_add_item_to_list_type"
      values={{ title: <BibScreenReaderDescription bibBrief={item} />, listType: <FormattedMessage id={shelfLabelEnum[this.props.currentShelfName]} /> }} />);
  }

  handleAdd(item) {
    return () => {
      const { shelfActions, currentShelfName } = this.props;
      this.setState({ isUpdatingResultItem: true });

      shelfActions.addToShelf(item.get('metadataId'), currentShelfName, () => {
        this.setState(prevState => ({
          itemsAddedHash: { ...prevState.itemsAddedHash, [item.get('metadataId')]: true },
          isUpdatingResultItem: false,
          anyTransactionSuccess: true
        }));
      });
    };
  }

  handleMove(item) {
    return () => {
      const { shelfActions, currentShelfName } = this.props;
      shelfActions.updateShelfItems({
        shelfName: item.get('shelf'),
        shelfItemIds: [item.get('id')],
        metadataIds: [item.get('metadataId')],
        newShelfName: currentShelfName,
        postSuccess: () => {
          this.setState(prevState => ({
            itemsAddedHash: { ...prevState.itemsAddedHash, [item.get('metadataId')]: true },
            isUpdatingResultItem: false,
            anyTransactionSuccess: true
          }));
        }
      });

      this.setState({ isUpdatingResultItem: true });
    };
  }

  renderAddOn(item) {
    const { currentUserShelves, currentShelfName } = this.props;
    const currentShelfItem = currentUserShelves.get(item.get('metadataId'));

    if (currentShelfItem) {
      if (currentShelfItem.get('shelf') === currentShelfName) {
        const alertLabel = (this.state.itemsAddedHash[item.get('metadataId')]) ? 'added_to_shelf' : 'on_shelf';
        return (<CatalogueResultItemAlert label={(<FormattedMessage id={alertLabel} />)} />);
      }
      return (
        <CatalogueResultItemButton
          icon={(<Arrows.move.Right className="result-item-icon" />)}
          label={(<FormattedMessage id="move_to_this_shelf" />)}
          item={item}
          screenReaderMessage={this.renderScreenReaderMessage(item)}
          handleClick={this.handleMove(currentShelfItem)} />
      );
    }

    return (
      <CatalogueResultItemButton
        icon={(<Plus />)}
        label={(<FormattedMessage id="add_to_shelf" />)}
        item={item} screenReaderMessage={this.renderScreenReaderMessage(item)}
        handleClick={this.handleAdd(item)} />
    );
  }

  render() {
    return (
      <PrimaryButton
        handleClick={this.openEditor}
        className="cp-shelf-add-title-button">
        <Plus /> <FormattedMessage id="label_add_title" />
        <AddTitleOverlay open={!!this.state.showEditor} handleClose={this.closeEditor}>
          {this.renderOverlay()}
        </AddTitleOverlay>
      </PrimaryButton>
    );
  }
}

const WrappedShelfAddTitleButton = withRouter(ShelfAddTitleButton);

WrappedShelfAddTitleButton.propTypes = {
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  currentShelfName: PropTypes.string.isRequired,
  currentUserShelves: ImmutablePropTypes.map.isRequired,
  ownerId: PropTypes.number.isRequired,
  // from router wrapper
  location: locationShape
};

export default WrappedShelfAddTitleButton;



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfAddTitleButton/ShelfAddTitleButton.jsx